import React from "react";
import { useTranslation } from "react-i18next";
import Auth from "@rill/auth";
import LoginWrapper from "./LoginWrapper";
import { useRillContext } from "../rill/RillReact/share/base";

function View(props) {
  const { t } = useTranslation("auth");
  const { locals } = useRillContext();

  const email = locals.query.email || undefined;
  return (
    <LoginWrapper
      left={
        <form method="POST" action="/actions/user/reset-password" data-noreset>
          <div>
            <h1>{t("forgot.title")}</h1>
          </div>

          <label htmlFor="email">{t("forgot.emailLabel")}</label>
          <input
            type="email"
            name="email"
            placeholder={t("forgot.emailPlaceholder")}
            required
            defaultValue={email}
            sz="large"
          />

          <button data-button-type="primary" sz="large" type="submit">
            {t("forgot.submit")}
          </button>

          <a
            data-button-type="outline"
            role="button"
            sz="large"
            href="/login"
            className="mt-4!"
          >
            <span>{t("forgot.backToLogin")}</span>
          </a>
        </form>
      }
    />
  );
}

const Forgot = (app) => {
  app.get(
    "/forgot",
    Auth.isLoggedOut({ redirect: "dashboard" }),
    ({ res }) => (res.body = <View />)
  );
};

export default Forgot;
